import React, { useState } from "react"
import { Offcanvas, CloseButton, Button, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { FaSortAlphaDown, FaCalendarAlt, FaSyncAlt } from 'react-icons/fa';
import XDocList from "./XDocList";
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore'
import { spinner } from "../utils/Helper"
import { toast } from 'react-toastify'
import { CreateDoc } from "./XDocList"; // Updated to use the consolidated export

import doc1 from '../images/doc.png';
import './xDocList.css';

export default function Docz(props) {
    const { theme = 'dark' } = props;
    const isDark = theme === 'dark';

    const [showCanvas, setShowCanvas] = useState(false);
    const [xDocz, setXDocz] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: 'created', direction: 'desc' });

    const isPublicView = props.public === true;

    // --- Styles Mapping based on Theme ---
    const themeStyles = {
        backdrop: isDark ? "bg-dark adminBackdrop" : "bg-light docLight border-start ",
        offcanvas: isDark ? "bg-dark" : " xlight border-start",
        text: isDark ? "text-white" : "text-dark",
        subText: isDark ? "text-white-50" : "text-muted",
        search: isDark ? "glass-search mb-2" : "form-control border-light-subtle  mb-2",
        headerBorder: isDark ? "border-secondary border-opacity-20" : "border-light-subtle",
        title: isDark ? "modified xTitle m-0" : "fw-bold text-dark m-0 h3"
    };

    const getXDocs = () => {
        const db = getFirestore();
        spinner(true);
        const docsRef = collection(db, "docs");
        let q;

        if (isPublicView) {
            q = query(docsRef, where("isPrivate", "==", false));
        } else {
            q = query(docsRef);
        }

        getDocs(q).then((snapshot) => {
            let rec = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            setXDocz(rec);
            spinner(false);
            setShowCanvas(true);
        }).catch(err => {
            spinner(false);
            console.error("Firestore Error:", err);
            toast.error(err.message);
        });
    }

    const getLastUpdatedDate = () => {
        if (xDocz.length === 0) return "N/A";
        const latest = xDocz.reduce((max, doc) => {
            const current = doc.updated?.seconds || doc.created?.seconds || 0;
            return current > max ? current : max;
        }, 0);
        return latest === 0 ? "N/A" : new Date(latest * 1000).toLocaleDateString('en-US', {
            month: 'short', day: 'numeric', year: 'numeric'
        });
    };

    const toggleSort = (key) => {
        let direction = 'desc';
        if (sortConfig.key === key && sortConfig.direction === 'desc') {
            direction = 'asc';
        }
        setSortConfig({ key, direction });
    };

    const filteredAndSortedDocs = xDocz
        .filter(doc => doc.name?.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => {
            let valA = a[sortConfig.key];
            let valB = b[sortConfig.key];
            if (sortConfig.key === 'created') {
                valA = a.created?.seconds || 0;
                valB = b.created?.seconds || 0;
            } else if (typeof valA === 'string') {
                valA = valA.toLowerCase();
                valB = valB.toLowerCase();
            }
            if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
            if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });

    return (
        <>
            
                {isPublicView ? (
                    <Button onClick={getXDocs} className="">
                        <img src={doc1} alt="Document Icon" className="thumb hoverX" />
                        <br />
                        <span className="hoverX"> Documents</span>
                    </Button>
                ) : (
                    <Button variant={isDark ? "primary" : "outline-primary"} onClick={getXDocs} className="hoverX shadow-sm">
                        <span className="circle-btn centerCircle">🎲</span>Docz
                    </Button>
                )}
          

            <Offcanvas
                show={showCanvas}
                onHide={() => setShowCanvas(false)}
                placement="end"
                className={themeStyles.offcanvas}
                backdropClassName={themeStyles.backdrop}
            >
                <Offcanvas.Header className={`pb-2 border-bottom ${themeStyles.headerBorder}`}>
                    <div className="w-100">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h3 className={themeStyles.title}>{isPublicView ? "Docz" : "Docz"}</h3>
                            <div className="d-flex align-items-center gap-2">
                                {!isPublicView && <CreateDoc theme={theme} onSuccess={getXDocs} />}
                                <CloseButton variant={isDark ? "white" : undefined} onClick={() => setShowCanvas(false)} />
                            </div>
                        </div>

                        <Form.Control
                            type="search"
                            placeholder="🔎 Search docs..."
                            className={themeStyles.search}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        {/* REFRESH & LAST UPDATED SECTION */}
                        <div className="d-flex align-items-center justify-content-between mb-3 ps-1">
                            <div className="d-flex align-items-center gap-2" style={{ opacity: 0.7 }}>
                                <FaSyncAlt
                                    className="text-info pointer hover-spin"
                                    size={12}
                                    onClick={getXDocs}
                                />
                                <span className={`meta-label m-0 ${themeStyles.subText}`} style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                                    LAST UPDATED: <span className={themeStyles.text}>{getLastUpdatedDate()}</span>
                                </span>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex gap-2">
                                <button className={`btn-sort-pill ${sortConfig.key === 'created' ? 'active' : ''}`} onClick={() => toggleSort('created')}>
                                    <FaCalendarAlt className="me-1" size={10} />
                                    Date {sortConfig.key === 'created' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                </button>
                                <button className={`btn-sort-pill ${sortConfig.key === 'name' ? 'active' : ''}`} onClick={() => toggleSort('name')}>
                                    <FaSortAlphaDown className="me-1" size={10} />
                                    Name {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                </button>
                            </div>
                            <div className="stats-badge m-0">
                                <span className="value">{filteredAndSortedDocs.length} Docs</span>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="custom-scrollbar">
                    <ul className="doc-container p-0 padding">
                        {filteredAndSortedDocs.map((x) => (
                            <XDocList
                                key={x.id}
                                {...x}
                                theme={theme}
                                public={isPublicView}
                                onDeleteSuccess={getXDocs}
                            />
                        ))}
                    </ul>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}